import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductosService } from '../services/productos.service';

@Component({
  selector: 'app-copiar-tipos-credito-dialog',
  templateUrl: './copiar-tipos-credito-dialog.component.html'
})
export class CopiarTiposCreditoDialogComponent implements OnInit {
  @Output() formResult = new EventEmitter<any>();
  form: FormGroup;
  tiposCredito: any[] = [];
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private productosService: ProductosService
  ) {
    this.form = this.fb.group({
      origen: ['', [Validators.required]],
      destino: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.cargarTiposCredito();
  }

  cargarTiposCredito(): void {
    this.loading = true;
    this.productosService.read().subscribe({
      next: (response) => {
        if (response.data) {
          this.tiposCredito = response.data.map((item: any) => ({
            label: `${item.producto} | ${item.descripcion}`,
            value: item.producto
          }));
        }
      },
      error: (error) => {
        console.error('Error al cargar tipos de crédito:', error);
        this.formResult.emit({ 
          refresh: false, 
          success: false, 
          error: 'Error al cargar los tipos de crédito' 
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.loading = true;
      const request = {
        origen: this.form.get('origen')?.value,
        destino: this.form.get('destino')?.value
      };

             // Aquí deberías implementar el método de copiar en el servicio
       this.productosService.copy(request).subscribe({
         next: (response) => {
           if (response.data && response.data[0] && response.data[0].error === "0") {
             this.formResult.emit({ 
               refresh: true, 
               success: true,
               message: 'Tipo de crédito copiado correctamente'
             });
           } else {
             this.formResult.emit({ 
               refresh: false, 
               success: false,
               error: 'Error al copiar el tipo de crédito'
             });
           }
         },
        error: (error) => {
          console.error('Error al copiar tipo de crédito:', error);
          this.formResult.emit({ 
            refresh: false, 
            success: false,
            error: 'Error al copiar el tipo de crédito'
          });
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }
}
